import {
    MdErrorOutline,
    MdKeyboardArrowDown,
    MdArrowForwardIos,
    MdChevronRight,
    MdCheck,
    MdAdd,
    MdLocalBar,
    MdCached,
    MdInventory,
    MdLightMode,
    MdSentimentVerySatisfied,
    MdClose,
    MdWhatsapp,
    MdKeyboardArrowRight,
    MdOutlineShoppingCart,
    MdOutlinePayments,
    MdCreditCard,
    MdCircleNotifications,
    MdOutlineExpandLess,
    MdOutlineExpandMore,
    MdLocalOffer,
    MdTune,
    MdSearch,
    MdAllInbox,
    MdAutorenew,
    MdDeleteOutline,
    MdExpandMore,
    MdError,
    MdOutlineInfo,
    MdOutlineErrorOutline,
    MdOutlineWarningAmber,
    MdChevronLeft,
    MdArrowBack,
    MdOutlineArrowBack,
    MdWarningAmber,
    MdOutlineBrightness7,
    MdClear,
    MdRemove,
    MdReplay,
    MdAddShoppingCart,
    MdLinkOff,
    MdAddCircle,
  } from 'react-icons/md'

  const MaterialDesign = {
    MdErrorOutline,
    MdKeyboardArrowDown,
    MdArrowForwardIos,
    MdChevronRight,
    MdCheck,
    MdAdd,
    MdAddCircle,
    MdLocalBar,
    MdCached,
    MdInventory,
    MdLightMode,
    MdSentimentVerySatisfied,
    MdClose,
    MdWhatsapp,
    MdKeyboardArrowRight,
    MdOutlineShoppingCart,
    MdOutlinePayments,
    MdCreditCard,
    MdCircleNotifications,
    MdOutlineExpandLess,
    MdOutlineExpandMore,
    MdLocalOffer,
    MdTune,
    MdSearch,
    MdAllInbox,
    MdAutorenew,
    MdDeleteOutline,
    MdExpandMore,
    MdError,
    MdOutlineInfo,
    MdOutlineErrorOutline,
    MdOutlineWarningAmber,
    MdChevronLeft,
    MdArrowBack,
    MdOutlineArrowBack,
    MdWarningAmber,
    MdOutlineBrightness7,
    MdClear,
    MdRemove,
    MdReplay,
    MdAddShoppingCart,
    MdLinkOff
  }

  export default MaterialDesign